import { useState, useEffect, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { CarrierService } from "../../services/CarrierService";
import { AlertContext } from "../../components/Dashboard/Dashboard";

export default function useSidebarReceiver(activeUser) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [connection, setConnection] = useState(null);
  const [carrierNetwork, setCarrierNetwork] = useState([]);
  const [newItem, setNewItem] = useState({});
  const [viewingUser, setViewingUser] = useState("");

  const getCarrierNetwork = () => {
    if (viewingUser) {
      setTimeout(() => {
        CarrierService.GetCarrierNetwork(instance, viewingUser).then(res => {
          res.forEach(c => { c.isNew = false; c.checkMark = false; });
          setCarrierNetwork(res);
        }).catch(error => {
          console.error(error);
          warning(error);
        });
      }, 1);
    }
  };

  useEffect(() => {
    getCarrierNetwork();
  }, [viewingUser]);

  useEffect(() => {
    if (activeUser.userIdMcld) {
      const newConnection = new HubConnectionBuilder()
        .withUrl("/LeadRelationshipNotifications")
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

      newConnection.onreconnected(() => {
        newConnection.invoke("AddToGroup", activeUser.userIdMcld);
      });

      setConnection(newConnection);
      setViewingUser(activeUser.userIdMcld);
    }
  }, [activeUser]);

  useEffect(() => {
    async function start() {
      try {
        await connection.start();
        await connection.invoke("AddToGroup", activeUser.userIdMcld);

        connection.on("SidebarChange", update => {
          update.isNew = true;
          update.checkMark = false;
          setNewItem(update);
        });
      } catch (err) {
        console.error(err);
      }
    }

    if (connection) {
      start();
    }
  }, [connection]);

  useEffect(() => {
    if (newItem) {
      let updatedNetwork = [...carrierNetwork];
      const index = updatedNetwork.findIndex(c => c.carrierId == newItem.carrierId);

      if (viewingUser === newItem.carrierMgr) {
        index >= 0 ? updatedNetwork[index] = newItem : updatedNetwork.push(newItem);
      } else if (viewingUser !== newItem.carrierMgr && index >= 0) {
        updatedNetwork.splice(index, 1);
      }

      setCarrierNetwork(updatedNetwork);
    }
  }, [newItem]);

  return {
    carrierNetwork,
    viewingUser,
    setViewingUser
  };
}